import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { BranchShowDto, CountryOptionDto } from "apiGen";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CountrySelectField, StateSelectField } from "~root/country/CountrySelectField";
import { branchService } from "~shared/api/branch/branch_service";

export type IBranchFormState = Omit<BranchShowDto, "id" | "country"> & {
	country: CountryOptionDto | null;
};

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IBranchFormState) => {
		const errors: { [K in keyof IBranchFormState]?: any } = {};

		if (!values.name) {
			errors.name = t("Field is required");
		}
		if (!values.street) {
			errors.street = t("Field is required");
		}
		if (!values.houseNumber) {
			errors.houseNumber = t("Field is required");
		}
		if (!values.zip) {
			errors.zip = t("Field is required");
		}
		if (!values.city) {
			errors.city = t("Field is required");
		}
		if (!values.country) {
			errors.country = t("Field is required");
		}
		return errors;
	};
};

const BranchDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
			<TextField name="street" label={t("Street")} required />
			<TextField name="houseNumber" label={t("House number")} required />
			<TextField name="zip" label={t("Zip")} required />
			<TextField name="city" label={t("City")} required />
			<StateSelectField name="state" label={t("State")} />
			<CountrySelectField name="country" label={t("Country")} required />
		</FormDrawerContent>
	);
};

const initialValues: IBranchFormState = {
	name: "",
	street: "",
	houseNumber: "",
	zip: "",
	city: "",
	state: null,
	country: null,
};

export const BranchCreateDrawer: FC<CreateDrawerFormProps<IBranchFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Add branch")}
			initialValues={initialValues}
			validate={validate}
			renderForm={(props) => <BranchDrawerContent {...props} />}
		/>
	);
};

export const BranchUpdateDrawer: FC<UpdateDrawerFormProps<IBranchFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			queryFn={() => branchService.show(drawerProps.id).then((x) => x.data.data)}
			queryKey={branchService.showKey(drawerProps.id)}
			title={t("Edit branch")}
			validate={validate}
			renderSuccess={(props) => <BranchDrawerContent {...props} />}
		/>
	);
};
